import { Component, Inject, InjectionToken, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SHARED_MODULES } from '../../../../shared.';
import { IInjectedElementDtype } from '../../../models/InjectedElementDtype';

export const ELEMENT = new InjectionToken<any>('element', { providedIn: 'root', factory: () => 'element' });

type MasterRuleDimensionsDtypeElement = {
	brand_names: string;
	category_names: string;
	supplier_names: string;
	marker_names: string;
	shelf_numbers: string;
};

@Component({
	selector: 'app-master-rule-dimensions-dtype',
	templateUrl: './master-rule-dimensions-dtype.component.html',
	styleUrls: ['./master-rule-dimensions-dtype.component.scss'],
	imports: [SHARED_MODULES],
	standalone: true
})
export class MasterRuleDimensionsDtypeComponent implements OnInit {
	protected displayValue: string = '';
	protected tooltipValue: string = '';
	protected element: MasterRuleDimensionsDtypeElement;

	constructor(
		@Inject(ELEMENT) private readonly elementInjected: IInjectedElementDtype<MasterRuleDimensionsDtypeElement>,
		private readonly translate: TranslateService
	) {}

	ngOnInit(): void {
		this.element = this.elementInjected.element;

		const items: Array<string> = [
			this.getItem('CATEGORIES', this.element?.category_names),
			this.getItem('BRANDS', this.element?.brand_names),
			this.getItem('SUPPLIERS', this.element?.supplier_names),
			this.getItem('CHARACTERISTIC', this.element?.marker_names),
			this.getItem('RULES.GROUP.SHELVES', this.element?.shelf_numbers)
		].filter((x: string) => !!x);

		this.displayValue = items.join(' - ');
		this.tooltipValue = items.join('\n');
	}

	private getItem(label: string, value: string): string {
		return (value ?? '').trim() ? `${this.translate.instant(label)}: ${value}` : '';
	}
}

